<template>
    <div>
        <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
            <form @submit.prevent="store">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                    <select-input-filter placeholder="Comece a digitar" :onInput="doFilter" :items="localCustomers"
                                         v-if="user_access.ticket.update && auth.user.role.slug !== 'customer'"
                                         v-model="form.user_id" :error="form.errors.user_id"
                                         class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Cliente')">
                    </select-input-filter>

                    <select-input v-if="user_access.ticket.update" v-model="form.priority_id" :error="form.errors.priority_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Prioridade')">
                        <option :value="null" />
                        <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>

                    <select-input ref="category" v-if="false" @change="getSubCategories()" v-model="form.category_id" :error="form.errors.category_id" class="pb-5 pr-6 md:col-span-6 lg:w-1/3" :label="__('Categoria')">
                        <option :value="null">{{ __('Selecione uma categoria') }}</option>
                        <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                    </select-input>

                    <select-input ref="sub_category" v-if="false" v-model="form.sub_category_id" :error="form.errors.sub_category_id" class="pb-5 md:col-span-6 lg:w-1/3" :label="__('Subcategoria')">
                        <option :value="null">{{ __('Selecione uma subcategoria') }}</option>
                        <option v-for="category in sub_categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                    </select-input>

                    <select-input-filter placeholder="Comece a digitar" :onInput="doFilterUsersExceptCustomer" :items="localUsersExceptCustomers"
                                         v-if="auth.user.role.slug !== 'customer' && user_access.ticket.update && !(hiddenFields && hiddenFields.includes('assigned_to'))"
                                         v-model="form.assigned_to" :error="form.errors.assigned_to"
                                         class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Atribuído a')">
                    </select-input-filter>

                    <!-- Produto associado ao ticket -->
                    <select-input
                        v-model="form.service_id"
                        :error="form.errors.service_id"
                        class="pr-6 pb-8 w-full lg:w-1/3"
                        :label="__('Produto')"
                    >
                        <option :value="null">{{ __('Selecione um produto') }}</option>
                        <option v-for="s in availableServices" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>

                    <text-input v-model="form.subject" :error="form.errors.subject" class="pr-6 pb-8 w-full lg:w-full" :label="__('Assunto')" />

                    <div class="pr-6 pb-8 w-full">
                        <label class="form-label">{{ __('Detalhes da solicitação:') }}</label>
                        <ckeditor id="ticketDetails" :editor="editor" v-model="form.details" :config="editorConfig"></ckeditor>
                    </div>

                    <input ref="file" type="file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip" class="hidden" multiple="multiple" @change="fileInputChange" />

                    <div class="pr-6 pb-8 w-full lg:w-full flex-col">
                        <button type="button" class="btn flex justify-center items-center" @click="fileBrowse">
                            <icon name="file" class="flex-shrink-0 h-8 fill-gray-400 pr-1" /> <h4>{{ __('Anexar arquivos') }}</h4>
                        </button>
                        <template v-if="form.files.length">
                            <div class="flex items-center justify-between pr-6 pt-8 w-full lg:w-1/2" v-for="(file, fi) in form.files" :key="fi">
                                <div class="flex-1 pr-1">
                                    {{ file.name }} <span class="text-gray-500 text-xs">({{ getFileSize(file.size) }})</span>
                                </div>
                                <button type="button" class="btn flex justify-center items-center" @click="fileRemove(file, fi)">
                                    {{ __('Remover') }}</button>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        {{ __('Criar Ticket') }}
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import LoadingButton from '@/Shared/LoadingButton'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import UploadAdapter from '@/Shared/UploadAdapter'
import CKEditor from '@ckeditor/ckeditor5-vue'
import axios from 'axios'

export default {
    name: 'TicketCreate',
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        Icon,
        ckeditor: CKEditor.component,
    },
    layout: Layout,
    props: {
        customers: Array,
        usersExceptCustomers: Array,
        priorities: Array,
        statuses: Array,
        allCategories: Array,
        services: Array,
        auth: Object,
        hiddenFields: Object,
    },
    remember: false,
    data() {
        return {
            user_access: this.$page.props.auth.user.access,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|', 'undo', 'redo'],
                table: {
                    toolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                extraPlugins: [this.uploader],
            },
            categories: [],
            sub_categories: [],
            availableServices: this.services || [],
            localCustomers: [...(this.customers || [])],
            localUsersExceptCustomers: [...(this.usersExceptCustomers || [])],
            form: this.$inertia.form({
                user_id: null,
                priority_id: null,
                status_id: null,
                department_id: null,
                category_id: null,
                sub_category_id: null,
                assigned_to: null,
                type_id: null,
                service_id: null,
                subject: null,
                details: '',
                files: [],
            }),
        }
    },
    watch: {
        'form.user_id'(userId) {
            this.form.service_id = null
            if (userId) {
                axios.get(this.route('services.by_user', userId)).then(res => {
                    this.availableServices = res.data
                })
            } else {
                this.availableServices = this.services || []
            }
        },
    },
    created() {
        this.setDefaultValue(this.statuses, 'status_id', 'Pending')
        this.setDefaultValue(this.priorities, 'priority_id', 'Generally')
    },
    methods: {
        getCategories() {
            this.categories = this.allCategories
            this.form.category_id = null
            this.$refs.category.selected = null
        },
        getSubCategories() {
            this.sub_categories = this.allCategories.filter(cat => cat.parent_id === this.form.category_id)
            this.form.sub_category_id = null
            this.$refs.sub_category.selected = null
        },
        uploader(editor) {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return new UploadAdapter(loader)
            }
        },
        doFilter(e) {
            axios.get(this.route('filter.customers', { search: e.target.value })).then((res) => {
                this.localCustomers = res.data
            })
        },
        doFilterUsersExceptCustomer(e) {
            axios.get(this.route('filter.users_except_customer', { search: e.target.value })).then((res) => {
                this.localUsersExceptCustomers = res.data
            })
        },
        setDefaultValue(arr, key, value) {
            const find = arr.find(i => i.name.match(new RegExp(value + '.*')))
            if (find) {
                this.form[key] = find['id']
            }
        },
        fileInputChange(e) {
            const selectedFiles = e.target.files
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i])
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1)
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        store() {
            this.form.user_id = this.auth.user.id
            this.form.post(this.route('tickets.store'))
        },
    },
}
</script>